import BASEURLGESTTOR from '../api/gesttor'
import { contratarSistemaPayload } from "../../interfaces/contratarSistema"

export function contratarSistema (payload: contratarSistemaPayload) {
    return BASEURLGESTTOR.post('/organizacao/assinante', payload)
}

export function cobrancas () {
    return BASEURLGESTTOR.get('/organizacao/cobrancas')
}